import * as React from 'react';
import { useMemo } from 'react';
import {
	ExarePriceDetailsGroupFragment,
	ExarePriceDetail_ExarePriceDetailsPriceElement_Fragment as DetailPriceElement,
	ExarePriceDetail_ExarePriceDetailsTaxElement_Fragment as DetailTaxPriceElement
} from '@websky/graphql';
import Money from '../../../../../../../Money';
import css from './ElementsPriceDetails.css';
import { useTranslation } from 'react-i18next';

interface Props {
	elements: ExarePriceDetailsGroupFragment;
	className?: string;
}

type DetailsByTypes = Partial<DetailPriceElement & DetailTaxPriceElement>;

const isTaxRetention = (element: any): element is DetailTaxPriceElement => {
	return (element as DetailTaxPriceElement).hasOwnProperty('taxCode');
};

const ElementsPriceDetails: React.FC<Props> = props => {
	const { t } = useTranslation('Exchange');

	const detailsByTypes = useMemo(() => {
		const byTypes = new Map<string, DetailsByTypes>();

		props.elements.elements?.forEach(element => {
			const elementKey = `${element.type}_${(element as DetailTaxPriceElement).taxCode || ''}`;
			const selectedElement = byTypes.get(elementKey);

			if (selectedElement) {
				const updateElement = {
					...selectedElement,
					money: {
						...selectedElement.money,
						amount: selectedElement.money.amount + element.money.amount
					}
				};
				byTypes.set(elementKey, updateElement);
			} else {
				const { passengerId, ...otherProperties } = element;
				byTypes.set(elementKey, otherProperties);
			}
		});

		return byTypes;
	}, [props.elements]);

	const details = Array.from(detailsByTypes);

	return (
		<div className={props.className}>
			{details.map(([type, element], idx) => {
				return (
					<div className={css.item} key={`${idx}${element.type}`} data-item-type={element.type}>
						<div>{isTaxRetention(element) ? `${t('Fee')} ${t(element.taxCode)}` : t(element.type)}</div>
						<Money
							money={{
								amount: Math.abs(element.money.amount),
								currency: element.money.currency
							}}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default ElementsPriceDetails;
